import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'altcha';
import 'altcha/i18n/pt-br';
import {
    AuthCard,
    FieldGroup,
    InputFull,
    ActionsWrapper,
    RecaptchaBox,
    isValidMail,
} from './AuthCard';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { Spinner } from '../../../shared/ui/Spinners';

type ForgotPasswordRequestCardProps = {
    email: string;
    message: string;
    isLogin: boolean;
    onBack: () => void;
    onChangeEmail: (v: string) => void;
    onRecaptchaChange: (v: string | null) => void; // vamos reaproveitar para enviar o payload ALTCHA
    onSubmit: () => void;
};

export const ForgotPasswordRequestCard: React.FC<
    ForgotPasswordRequestCardProps
> = ({
    email,
    message,
    isLogin,
    onBack,
    onChangeEmail,
    onRecaptchaChange,
    onSubmit,
}) => {
        const [isCaptchaReady, setCaptchaReady] = useState(false);

        const [captchaKey, setCaptchaKey] = useState(0);
        const resetCaptcha = useCallback(() => {
            setCaptchaReady(false);
            onRecaptchaChange(null);
            setCaptchaKey((k) => k + 1);
        }, [onRecaptchaChange]);
        const handleSubmit = useCallback(async () => {
            try {
                await onSubmit();
                resetCaptcha();
            } catch (e) {
                resetCaptcha();
                throw e;
            }
        }, [onSubmit, resetCaptcha]);

        return (
            <AuthCard
                title="Bem-vindo ao"
                subtitle="Recuperar acesso à sua conta"
                message={message}
                showBack
                onBack={onBack}
            >
                <FieldGroup>
                    <InputFull
                        placeholder="E-mail"
                        value={email}
                        onChange={(e) => onChangeEmail(e.target.value)}
                    />
                </FieldGroup>

                <RecaptchaBox
                    key={captchaKey}
                    isReady={isCaptchaReady}
                    onChangeReady={setCaptchaReady}
                    onChangePayload={onRecaptchaChange}
                />

                {isLogin ? (
                    <div
                        style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}
                    >
                        <Spinner />
                    </div>
                ) : (
                    <ActionsWrapper>
                        <PrimaryButton
                            onClick={handleSubmit}
                            disabled={!isCaptchaReady || !isValidMail(email)}
                        >
                            Enviar solicitação
                        </PrimaryButton>
                    </ActionsWrapper>
                )}
            </AuthCard>
        );
    };
